import React from "react";

const Weedle = ({ ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-1.85 -0.05 94.95 136.45"
      {...rest}
    >
      <g>
        <path
          fill="#0d131a"
          d="M85.2 82.95 Q81.75 82.65 79.15 80.1 77.6 78.6 77.45 75.6 L77.1 71.05 Q76.8 70.0 75.65 68.7 L73.4 66.5 Q72.25 65.4 72.4 64.9 72.5 64.4 74.15 64.35 84.75 63.95 89.6 68.65 92.7 71.65 92.75 75.8 92.8 79.6 90.5 81.5 88.4 83.2 85.2 82.95"
        />
        <path
          fill="#cad3cc"
          d="M89.65 80.1 Q87.8 81.8 85.15 81.65 82.45 81.4 80.2 79.25 78.95 78.05 78.7 75.2 L78.35 70.75 Q77.95 69.1 75.5 66.95 L74.3 65.7 Q74.25 65.35 76.0 65.45 84.65 66.05 88.5 69.8 90.95 72.15 91.2 75.4 91.4 78.5 89.65 80.1"
        />
        <path
          fill="#a6ada8"
          d="M89.65 80.1 Q87.8 81.8 85.15 81.65 82.45 81.4 80.2 79.25 79.4 78.55 79.1 77.35 82.85 79.25 86.35 78.1 90.05 76.95 90.65 73.1 91.45 75.1 91.15 77.05 90.85 79.0 89.65 80.1"
        />
        <path
          fill="#0d131a"
          d="M81.0 98.55 Q76.5 98.05 74.35 95.05 71.85 91.55 72.0 87.75 72.1 83.6 75.3 81.35 78.35 79.15 82.25 79.9 86.4 80.65 89.05 84.35 91.4 87.65 90.85 91.6 90.3 95.6 87.1 97.6 84.9 99.0 81.0 98.55"
        />
        <path
          fill="#e3c582"
          d="M82.2 81.3 Q85.5 82.1 87.6 85.0 89.7 87.95 89.35 91.35 89.0 94.7 86.4 96.55 83.8 98.4 80.5 97.65 77.2 96.9 75.1 93.95 73.0 91.05 73.35 87.65 73.7 84.25 76.3 82.4 78.9 80.55 82.2 81.3"
        />
        <path
          fill="#bfa56f"
          d="M87.95 85.6 Q89.75 88.45 89.3 91.6 88.85 94.8 86.4 96.55 83.8 98.4 80.5 97.65 77.2 96.9 75.1 93.95 73.5 91.65 73.35 89.2 L73.7 89.75 Q75.8 92.7 79.1 93.45 82.4 94.2 85.0 92.35 86.6 91.25 87.35 89.4 88.1 87.65 87.95 85.6"
        />
        <path
          fill="#0d131a"
          d="M68.15 91.6 Q71.25 88.85 75.8 89.45 80.35 90.0 83.65 93.55 86.95 97.15 86.8 102.05 86.65 106.65 83.75 109.05 80.7 111.65 76.1 111.25 71.2 110.85 67.95 107.1 64.65 103.25 64.85 98.65 65.05 94.25 68.15 91.6"
        />
        <path
          fill="#e3c582"
          d="M69.1 92.7 Q71.9 90.25 75.85 90.75 79.85 91.3 82.6 94.5 85.4 97.7 85.35 101.7 85.35 105.7 82.5 108.15 79.7 110.6 75.75 110.05 71.8 109.55 69.0 106.35 66.2 103.15 66.2 99.15 66.25 95.15 69.1 92.7"
        />
        <path
          fill="#bfa56f"
          d="M75.75 110.05 Q71.8 109.55 69.0 106.35 66.8 103.85 66.35 100.8 L66.9 101.45 Q69.7 104.65 73.65 105.15 77.6 105.7 80.4 103.25 82.1 101.8 82.8 99.6 83.5 97.5 83.15 95.15 85.55 98.3 85.35 102.05 85.2 105.85 82.5 108.15 79.7 110.6 75.75 110.05"
        />
        <path
          fill="#0d131a"
          d="M54.55 101.55 Q58.05 97.75 63.45 97.3 69.05 96.8 73.65 101.05 78.2 105.2 78.45 110.65 78.75 116.05 74.5 119.5 71.1 122.3 67.55 122.35 60.95 122.45 56.45 118.95 51.75 115.25 51.45 109.35 51.25 105.05 54.55 101.55"
        />
        <path
          fill="#e3c582"
          d="M58.2 117.7 Q54.5 114.35 53.95 109.7 53.45 105.0 56.4 101.75 59.3 98.5 64.05 98.55 68.75 98.6 72.45 101.95 76.15 105.3 76.65 109.95 77.2 114.65 74.25 117.9 71.3 121.15 66.6 121.1 61.9 121.05 58.2 117.7"
        />
        <path
          fill="#bfa56f"
          d="M76.75 111.3 Q76.7 115.15 74.25 117.9 71.3 121.15 66.6 121.1 61.9 121.05 58.2 117.7 54.9 114.8 54.1 110.55 L56.1 112.8 Q59.8 116.15 64.5 116.2 69.2 116.25 72.15 113.0 75.45 109.35 74.45 104.2 76.75 107.5 76.75 111.3"
        />
        <path
          fill="#0d131a"
          d="M41.35 129.9 Q36.4 127.5 33.45 120.65 31.35 115.75 33.3 110.25 35.4 104.25 41.4 101.65 48.0 98.8 55.35 101.55 62.7 104.25 65.5 110.75 67.85 116.2 65.3 122.05 62.4 128.75 54.45 130.5 46.4 132.3 41.35 129.9"
        />
        <path
          fill="#e3c582"
          d="M42.9 102.25 Q48.65 100.2 54.7 102.65 60.7 105.05 63.45 110.55 66.25 116.05 64.1 121.35 61.95 126.7 56.2 128.75 50.4 130.8 44.35 128.35 38.3 125.9 35.55 120.45 32.8 115.0 34.95 109.65 37.1 104.3 42.9 102.25"
        />
        <path
          fill="#bfa56f"
          d="M63.95 111.6 Q65.95 116.6 64.1 121.35 61.95 126.7 56.2 128.75 50.4 130.8 44.35 128.35 39.7 126.5 36.9 122.6 34.15 118.8 34.05 114.45 35.25 117.4 37.6 119.7 40.05 122.1 43.3 123.4 49.35 125.85 55.15 123.8 60.9 121.75 63.05 116.4 63.95 114.25 63.95 111.6"
        />
        <path
          fill="#0d131a"
          d="M41.4 134.55 Q32.45 134.7 27.25 129.55 22.8 125.2 22.8 119.35 22.8 112.5 27.45 108.2 32.3 103.65 40.55 103.65 48.35 103.65 53.55 108.2 58.5 112.55 58.5 118.6 58.5 124.95 53.85 129.55 49.0 134.4 41.4 134.55"
        />
        <path
          fill="#e3c582"
          d="M40.55 104.75 Q47.25 104.75 52.0 108.95 56.75 113.15 56.75 119.05 56.75 124.95 52.0 129.15 47.25 133.3 40.55 133.3 33.85 133.3 29.15 129.15 24.4 124.95 24.4 119.05 24.4 113.15 29.15 108.95 33.85 104.75 40.55 104.75"
        />
        <path
          fill="#bfa56f"
          d="M53.6 110.6 Q56.75 114.4 56.75 119.05 56.75 124.95 52.0 129.15 47.25 133.3 40.55 133.3 34.75 133.3 30.25 130.05 25.85 126.8 24.7 121.85 26.95 124.55 30.35 126.1 33.8 127.7 37.75 127.7 44.45 127.7 49.2 123.55 53.95 119.35 53.95 113.45 53.95 111.95 53.6 110.6"
        />
        <path
          fill="#0d131a"
          d="M54.55 94.8 Q59.6 99.35 59.6 105.8 59.6 112.55 54.6 116.8 49.7 121.0 42.1 121.05 33.85 121.1 28.7 116.55 23.8 112.2 23.8 105.75 23.8 98.9 29.05 94.45 34.15 90.15 41.6 90.15 49.35 90.15 54.55 94.8"
        />
        <path
          fill="#e3c582"
          d="M41.6 91.3 Q48.3 91.3 53.0 95.5 57.75 99.65 57.75 105.55 57.75 111.45 53.0 115.65 48.3 119.85 41.6 119.85 34.9 119.85 30.15 115.65 25.4 111.5 25.4 105.55 25.4 99.65 30.15 95.5 34.9 91.3 41.6 91.3"
        />
        <path
          fill="#bfa56f"
          d="M57.75 105.55 Q57.75 111.45 53.0 115.65 48.3 119.85 41.6 119.85 36.1 119.85 31.7 116.9 27.45 113.95 26.0 109.4 28.25 111.95 31.55 113.45 35.0 114.95 38.8 114.95 45.5 114.95 50.2 110.75 54.95 106.55 54.95 100.65 54.95 98.7 54.35 96.8 57.75 100.7 57.75 105.55"
        />
        <path
          fill="#0d131a"
          d="M38.55 70.85 Q47.7 70.85 54.15 76.85 59.9 82.2 59.9 88.15 59.9 96.15 53.7 101.65 47.55 107.2 38.65 107.2 30.45 107.2 24.3 102.3 17.7 97.0 17.7 89.1 17.7 82.05 23.15 76.75 29.15 70.85 38.55 70.85"
        />
        <path
          fill="#e3c582"
          d="M19.65 89.1 Q19.65 82.15 25.2 77.25 30.8 72.35 38.65 72.35 46.5 72.35 52.05 77.25 57.6 82.15 57.6 89.1 57.6 96.05 52.05 100.95 46.5 105.85 38.65 105.85 30.8 105.85 25.2 100.95 19.65 96.05 19.65 89.1"
        />
        <path
          fill="#bfa56f"
          d="M36.85 89.25 L26.85 88.75 Q22.15 87.8 19.95 85.95 21.25 80.1 26.45 76.25 31.75 72.35 38.65 72.35 43.6 72.35 47.9 74.45 52.05 76.5 54.65 80.05 49.95 88.1 36.85 89.25"
        />
        <path
          fill="#bfa56f"
          d="M56.9 84.5 Q57.6 86.75 57.6 89.1 57.6 96.05 52.05 100.95 46.5 105.85 38.65 105.85 32.6 105.85 27.65 102.8 22.85 99.75 20.8 94.9 23.5 97.65 27.15 99.2 31.0 100.8 35.25 100.8 43.7 100.8 49.05 97.25 55.3 93.15 56.9 84.5"
        />
        <path
          fill="#0d131a"
          d="M49.45 87.45 Q49.45 84.9 51.3 82.95 53.15 81.0 55.55 81.0 58.1 81.0 60.0 82.85 61.9 84.75 61.9 87.25 61.9 89.8 60.05 91.7 58.2 93.6 55.85 93.6 52.6 93.6 50.85 91.45 49.45 89.75 49.45 87.45"
        />
        <path
          fill="#e8528d"
          d="M55.55 92.6 Q53.5 92.6 52.1 91.05 50.65 89.5 50.65 87.3 50.65 85.15 52.1 83.6 53.55 82.05 55.55 82.05 57.6 82.05 59.0 83.6 60.45 85.15 60.45 87.3 60.45 89.5 59.0 91.05 57.6 92.6 55.55 92.6"
        />
        <path
          fill="#f3b3c9"
          d="M54.4 85.6 L53.45 86.15 Q52.95 86.2 52.6 85.9 52.3 85.6 52.4 85.1 52.5 84.55 52.9 84.1 53.35 83.7 53.9 83.6 L54.7 83.8 Q55.0 84.15 54.9 84.65 L54.4 85.6"
        />
        <path
          fill="#c9467c"
          d="M59.05 85.2 Q59.05 84.15 58.7 83.3 60.45 84.8 60.45 87.3 60.45 89.5 59.0 91.05 57.6 92.6 55.55 92.6 54.05 92.6 52.8 91.65 51.55 90.75 51.0 89.25 52.35 90.5 54.15 90.5 56.2 90.5 57.6 88.95 59.05 87.4 59.05 85.2"
        />
        <path
          fill="#0d131a"
          d="M49.9 110.05 Q50.4 107.55 52.6 106.25 54.6 105.0 56.8 105.45 59.1 105.9 60.4 107.95 61.7 110.05 61.2 112.55 60.75 114.6 58.85 115.9 56.8 117.25 54.35 116.75 51.85 116.2 50.6 114.15 49.45 112.25 49.9 110.05"
        />
        <path
          fill="#e8528d"
          d="M54.55 115.8 Q52.75 115.45 51.75 113.8 50.8 112.15 51.2 110.25 51.55 108.3 53.1 107.2 54.65 106.1 56.45 106.45 58.25 106.85 59.25 108.45 60.2 110.1 59.8 112.0 59.45 113.95 57.9 115.05 56.35 116.15 54.55 115.8"
        />
        <path
          fill="#f3b3c9"
          d="M54.8 109.4 L53.15 109.35 Q52.9 109.0 53.1 108.55 53.25 108.1 53.75 107.8 54.2 107.5 54.65 107.55 55.15 107.55 55.35 107.9 55.6 108.2 55.4 108.65 L54.8 109.4"
        />
        <path
          fill="#c9467c"
          d="M58.95 109.9 L59.0 108.15 Q60.25 109.9 59.8 112.0 59.45 113.95 57.9 115.05 56.35 116.15 54.55 115.8 53.2 115.5 52.25 114.45 51.35 113.4 51.15 112.0 52.1 113.3 53.7 113.7 55.45 114.05 57.0 112.95 58.6 111.8 58.95 109.9"
        />
        <path
          fill="#0d131a"
          d="M50.15 127.85 Q51.55 126.4 53.65 126.35 55.75 126.3 57.4 127.8 58.95 129.15 59.15 131.25 59.35 133.35 58.05 134.7 56.65 136.2 54.3 136.1 52.05 136.05 50.7 134.7 49.15 133.2 48.95 131.3 48.75 129.35 50.15 127.85"
        />
        <path
          fill="#e8528d"
          d="M51.45 133.95 Q50.2 132.85 50.1 131.3 50.0 129.75 51.1 128.6 52.2 127.45 53.85 127.4 55.45 127.3 56.7 128.4 57.95 129.5 58.05 131.05 58.15 132.65 57.05 133.75 55.95 134.9 54.35 134.95 52.7 135.0 51.45 133.95"
        />
        <path
          fill="#f3b3c9"
          d="M54.25 129.65 L53.4 129.4 Q53.05 129.2 53.0 128.85 52.95 128.5 53.3 128.3 53.6 128.05 54.05 128.1 L54.9 128.35 55.3 128.85 55.0 129.4 54.25 129.65"
        />
        <path
          fill="#c9467c"
          d="M58.0 130.7 Q58.3 132.4 57.05 133.75 55.95 134.9 54.35 134.95 52.7 135.0 51.45 133.95 50.5 133.15 50.25 132.0 49.95 130.85 50.35 129.8 50.5 131.1 51.65 132.1 52.9 133.15 54.55 133.1 56.15 133.05 57.25 131.9 57.8 131.4 58.0 130.7"
        />
        <path
          fill="#0d131a"
          d="M61.6 119.95 Q63.1 119.0 65.0 119.3 66.95 119.6 68.2 121.15 69.3 122.5 69.15 124.3 69.0 126.2 67.4 127.25 66.05 128.1 64.0 127.75 62.0 127.4 61.0 126.2 59.9 124.85 59.9 123.1 59.9 121.05 61.6 119.95"
        />
        <path
          fill="#c9467c"
          d="M66.2 120.65 L67.3 121.55 Q68.2 122.7 68.0 124.0 67.8 125.35 66.65 126.1 65.5 126.85 64.0 126.6 62.55 126.35 61.65 125.2 L61.35 124.7 Q62.25 125.25 63.3 125.25 64.4 125.25 65.25 124.7 66.3 124.05 66.55 122.85 66.8 121.7 66.2 120.65"
        />
        <path
          fill="#e8528d"
          d="M65.25 124.7 Q64.4 125.25 63.3 125.25 62.25 125.25 61.35 124.7 60.75 123.65 61.0 122.5 61.25 121.3 62.3 120.65 63.15 120.1 64.25 120.1 65.3 120.1 66.2 120.65 66.8 121.7 66.55 122.85 66.3 124.05 65.25 124.7"
        />
        <path
          fill="#f3b3c9"
          d="M64.1 121.9 L63.4 122.15 62.8 121.9 Q62.65 121.7 62.8 121.4 62.9 121.05 63.25 120.85 63.65 120.6 64.0 120.6 L64.55 120.8 Q64.95 121.3 64.1 121.9"
        />
        <path
          fill="#0d131a"
          d="M77.2 110.75 Q78.9 111.15 79.95 112.5 81.05 113.9 80.8 115.5 80.6 116.95 79.2 117.8 77.65 118.75 75.6 118.4 73.95 118.1 73.0 116.7 72.2 115.4 72.35 114.05 72.5 112.5 73.9 111.45 75.35 110.35 77.2 110.75"
        />
        <path
          fill="#c9467c"
          d="M77.15 115.7 Q78.1 115.1 78.35 114.05 78.55 113.05 78.0 112.1 78.65 112.45 79.0 112.9 79.8 113.9 79.65 115.1 79.45 116.3 78.45 116.95 77.4 117.65 76.05 117.4 74.75 117.15 73.95 116.15 L73.65 115.75 Q75.55 116.8 77.15 115.7"
        />
        <path
          fill="#e8528d"
          d="M77.15 115.7 Q75.55 116.8 73.65 115.75 73.1 114.75 73.35 113.75 73.6 112.7 74.55 112.1 75.3 111.6 76.25 111.6 77.2 111.6 78.0 112.1 78.55 113.05 78.35 114.05 78.1 115.1 77.15 115.7"
        />
        <path
          fill="#f3b3c9"
          d="M76.15 113.2 Q75.3 113.65 75.0 113.2 74.65 112.75 75.4 112.25 L76.05 112.0 76.55 112.2 Q76.95 112.7 76.15 113.2"
        />
        <path
          fill="#0d131a"
          d="M85.65 97.7 Q87.4 97.95 88.4 99.15 89.35 100.25 89.3 101.6 89.25 103.0 87.75 103.9 86.35 104.75 84.7 104.4 83.1 104.05 82.25 102.95 81.5 102.0 81.55 100.85 81.6 99.25 83.1 98.35 84.4 97.55 85.65 97.7"
        />
        <path
          fill="#c9467c"
          d="M87.5 99.45 Q88.3 100.3 88.2 101.4 88.1 102.45 87.2 103.15 86.3 103.8 85.1 103.65 83.95 103.5 83.15 102.65 L82.85 102.3 Q84.65 103.1 86.0 102.05 86.8 101.45 86.95 100.5 87.1 99.6 86.55 98.75 87.1 99.0 87.5 99.45"
        />
        <path
          fill="#e8528d"
          d="M83.45 98.95 Q84.1 98.45 84.95 98.4 L86.55 98.75 Q87.1 99.6 86.95 100.5 86.8 101.45 86.0 102.05 84.65 103.1 82.85 102.3 82.3 101.45 82.5 100.5 82.65 99.55 83.45 98.95"
        />
        <path
          fill="#f3b3c9"
          d="M84.95 99.85 L83.9 99.95 Q83.55 99.6 84.2 99.05 L85.25 98.95 Q85.6 99.4 84.95 99.85"
        />
        <path
          fill="#0d131a"
          d="M12.6 92.15 Q12.6 89.35 14.65 87.45 16.55 85.65 18.95 85.65 21.45 85.65 23.25 87.55 25.05 89.45 25.05 92.0 25.1 94.65 23.35 96.5 21.55 98.4 18.85 98.4 16.9 98.4 15.1 97.15 12.6 95.4 12.6 92.15"
        />
        <path
          fill="#e8528d"
          d="M18.85 97.25 Q16.8 97.25 15.4 95.7 13.95 94.15 13.95 91.95 13.95 89.8 15.4 88.25 16.85 86.7 18.85 86.7 20.9 86.7 22.3 88.25 23.75 89.8 23.75 91.95 23.75 94.15 22.3 95.7 20.9 97.25 18.85 97.25"
        />
        <path
          fill="#f3b3c9"
          d="M17.65 90.25 L16.7 90.75 Q16.2 90.85 15.9 90.55 15.6 90.2 15.7 89.7 15.75 89.15 16.2 88.75 16.6 88.3 17.15 88.25 L17.95 88.45 Q18.3 88.75 18.2 89.3 L17.65 90.25"
        />
        <path
          fill="#c9467c"
          d="M18.85 97.25 Q17.3 97.25 16.05 96.3 14.85 95.4 14.3 93.9 15.7 95.15 17.45 95.15 19.5 95.15 20.9 93.6 22.35 92.05 22.35 89.85 L22.0 87.9 Q23.75 89.55 23.75 91.95 23.75 94.15 22.3 95.7 20.9 97.25 18.85 97.25"
        />
        <path
          fill="#0d131a"
          d="M20.6 115.05 Q20.15 112.7 21.6 110.6 23.05 108.45 25.4 108.0 27.5 107.6 29.5 109.1 31.5 110.55 31.95 112.8 32.4 115.0 31.2 116.9 29.95 118.95 27.6 119.4 25.0 119.95 22.95 118.55 21.05 117.25 20.6 115.05"
        />
        <path
          fill="#e8528d"
          d="M27.25 118.45 Q25.45 118.8 23.95 117.65 22.45 116.55 22.05 114.6 21.7 112.7 22.65 111.1 23.65 109.5 25.45 109.1 27.25 108.75 28.8 109.9 30.35 111.0 30.7 112.95 31.1 114.85 30.05 116.5 29.05 118.1 27.25 118.45"
        />
        <path
          fill="#f3b3c9"
          d="M25.05 112.45 Q24.3 113.5 23.5 113.05 23.15 112.85 23.15 112.35 23.15 111.85 23.45 111.4 23.75 110.95 24.2 110.8 L25.0 110.85 25.35 111.55 25.05 112.45"
        />
        <path
          fill="#c9467c"
          d="M29.1 111.35 Q28.85 110.25 28.45 109.7 30.25 110.75 30.7 112.95 31.1 114.85 30.05 116.5 29.05 118.1 27.25 118.45 L24.65 118.1 Q23.4 117.5 22.65 116.3 24.15 117.15 25.65 116.85 27.45 116.5 28.45 114.85 29.5 113.25 29.1 111.35"
        />
        <path
          fill="#0d131a"
          d="M21.6 132.4 Q21.2 130.6 22.25 128.95 23.45 127.15 25.7 126.75 27.85 126.4 29.65 127.5 31.35 128.6 31.75 130.4 32.25 132.5 30.95 134.15 29.7 135.65 27.65 136.0 25.3 136.4 23.6 135.3 22.0 134.3 21.6 132.4"
        />
        <path
          fill="#e8528d"
          d="M27.4 135.05 Q25.8 135.3 24.4 134.45 23.05 133.55 22.7 132.0 22.35 130.45 23.3 129.15 24.2 127.85 25.8 127.6 27.4 127.3 28.8 128.2 30.15 129.1 30.5 130.65 30.85 132.2 29.95 133.45 29.0 134.75 27.4 135.05"
        />
        <path
          fill="#f3b3c9"
          d="M25.4 130.25 L24.75 130.75 24.05 130.7 Q23.75 130.5 23.75 130.15 23.7 129.75 24.0 129.4 L24.65 128.9 25.35 128.95 25.7 129.5 25.4 130.25"
        />
        <path
          fill="#c9467c"
          d="M29.95 133.45 Q29.0 134.75 27.4 135.05 L25.05 134.75 Q23.95 134.3 23.3 133.3 24.5 134.0 26.0 133.75 27.6 133.5 28.5 132.2 29.4 130.9 29.05 129.35 L28.5 128.0 Q30.1 128.9 30.5 130.65 30.85 132.2 29.95 133.45"
        />
        <path
          fill="#0d131a"
          d="M65.55 48.1 Q67.95 60.65 60.8 70.8 53.65 80.95 40.15 84.0 25.75 87.2 14.3 80.25 3.35 73.6 0.6 61.35 -1.85 50.15 4.7 39.85 12.1 28.35 27.25 25.15 41.15 22.25 52.5 29.5 63.3 36.4 65.55 48.1"
        />
        <path
          fill="#e3c582"
          d="M50.9 30.55 Q61.45 37.05 63.7 48.75 65.9 60.4 58.55 70.4 51.15 80.35 38.5 82.8 25.85 85.25 15.25 78.7 4.7 72.15 2.45 60.5 0.2 48.85 7.6 38.85 14.95 28.9 27.65 26.45 40.35 24.0 50.9 30.55"
        />
        <path
          fill="#bfa56f"
          d="M48.45 29.2 Q54.4 32.15 58.35 37.15 62.45 42.3 63.7 48.75 65.9 60.4 58.55 70.4 51.15 80.35 38.5 82.8 30.85 84.25 23.5 82.3 16.4 80.35 11.1 75.6 20.9 80.5 31.95 78.35 44.6 75.9 52.0 65.95 59.35 55.95 57.1 44.3 55.4 35.35 48.45 29.2"
        />
        <path
          fill="#0d131a"
          d="M18.0 61.8 Q17.15 57.35 20.6 52.75 24.5 47.7 31.3 46.4 37.9 45.1 43.4 48.05 48.7 50.95 49.6 55.85 50.55 60.9 46.85 65.45 42.95 70.1 36.25 71.4 30.65 72.45 25.35 70.25 19.1 67.65 18.0 61.8"
        />
        <path
          fill="#e8528d"
          d="M35.95 70.05 Q30.1 71.2 25.35 68.7 20.6 66.2 19.7 61.6 18.8 56.95 22.3 52.9 25.8 48.85 31.65 47.7 37.5 46.6 42.25 49.05 47.0 51.55 47.9 56.15 48.75 60.8 45.3 64.85 41.8 68.95 35.95 70.05"
        />
        <path
          fill="#f3b3c9"
          d="M28.35 55.45 Q26.8 56.2 25.45 56.05 24.25 55.9 23.9 55.3 23.5 54.45 24.3 53.35 25.1 52.25 26.5 51.55 28.0 50.8 29.4 50.95 30.65 51.1 31.0 51.8 31.4 52.7 30.75 53.65 30.0 54.7 28.35 55.45"
        />
        <path
          fill="#c9467c"
          d="M35.95 70.05 L28.15 69.8 Q24.55 68.8 22.25 66.4 26.7 68.25 31.85 67.3 37.7 66.2 41.2 62.1 44.65 58.05 43.8 53.4 43.3 50.7 41.25 48.6 43.9 49.7 45.65 51.65 47.4 53.65 47.9 56.15 48.75 60.8 45.3 64.85 41.8 68.95 35.95 70.05"
        />
        <path
          fill="#0d131a"
          d="M46.55 45.75 Q45.1 46.0 43.85 45.2 42.6 44.35 42.35 42.9 42.05 41.45 42.9 40.2 43.75 38.95 45.2 38.7 46.65 38.4 47.9 39.25 49.15 40.1 49.4 41.55 49.7 43.0 48.85 44.25 48.0 45.45 46.55 45.75"
        />
        <path
          fill="#ffffff"
          d="M45.05 42.45 L44.0 42.2 Q43.5 41.9 43.4 41.35 43.35 40.8 43.65 40.3 L44.5 39.7 Q45.1 39.65 45.55 39.95 46.05 40.25 46.15 40.8 L45.9 41.85 45.05 42.45"
        />
        <path
          fill="#0d131a"
          d="M12.55 48.6 Q12.3 47.15 13.1 45.9 13.95 44.65 15.4 44.4 16.85 44.1 18.1 44.95 19.35 45.8 19.65 47.25 19.9 48.7 19.05 49.95 18.25 51.15 16.8 51.45 15.35 51.75 14.1 50.9 12.85 50.05 12.55 48.6"
        />
        <path
          fill="#ffffff"
          d="M15.25 48.25 L14.25 48.05 Q13.75 47.7 13.65 47.15 13.55 46.6 13.85 46.1 14.2 45.6 14.75 45.5 15.3 45.45 15.8 45.75 16.25 46.05 16.35 46.6 16.45 47.15 16.15 47.65 15.8 48.15 15.25 48.25"
        />
        <path
          fill="#0d131a"
          d="M33.2 12.0 L40.45 24.5 Q41.25 26.05 41.25 27.0 41.25 28.05 40.3 28.9 36.75 31.95 29.75 32.95 22.8 33.95 18.55 32.1 17.15 31.5 16.85 30.55 16.55 29.65 16.85 27.1 17.4 22.3 19.5 14.25 21.45 6.75 23.0 2.85 24.05 0.15 24.6 0.05 25.2 -0.05 26.9 2.2 L33.2 12.0"
        />
        <path
          fill="#cad3cc"
          d="M24.15 3.6 L24.75 2.2 Q25.05 2.1 25.95 3.45 30.45 10.1 38.5 24.7 39.4 26.35 39.2 27.2 39.0 28.05 37.45 29.0 34.3 31.0 29.4 31.7 L21.3 31.45 Q19.35 30.95 18.85 30.4 18.4 29.85 18.55 28.4 18.95 24.6 20.5 17.65 22.2 10.0 24.15 3.6"
        />
        <path
          fill="#a6ada8"
          d="M38.5 24.7 Q39.4 26.35 39.2 27.2 39.0 28.05 37.45 29.0 34.3 31.0 29.4 31.7 L21.3 31.45 Q19.35 30.95 18.85 30.4 18.4 29.85 18.55 28.4 L18.75 26.7 Q19.8 27.9 23.25 28.25 26.75 28.55 29.9 27.6 38.35 24.95 33.9 16.5 L38.5 24.7"
        />
        <path
          fill="#0d131a"
          d="M89.8 87.2 Q91.35 87.45 92.25 88.55 93.1 89.5 93.05 90.7 93.0 92.0 91.65 92.8 90.4 93.55 88.9 93.25 87.5 92.95 86.7 91.95 86.05 91.05 86.1 90.05 86.15 88.65 87.45 87.8 88.65 87.05 89.8 87.2"
        />
        <path
          fill="#c9467c"
          d="M89.3 92.55 Q88.2 92.45 87.5 91.65 L87.25 91.35 Q88.8 92.15 90.1 91.15 90.8 90.65 90.95 89.75 91.1 88.9 90.6 88.15 L91.45 88.8 Q92.15 89.55 92.05 90.55 91.95 91.5 91.15 92.1 90.35 92.7 89.3 92.55"
        />
        <path
          fill="#e8528d"
          d="M90.1 91.15 Q88.8 92.15 87.25 91.35 86.75 90.6 86.9 89.75 87.05 88.85 87.75 88.35 89.1 87.4 90.6 88.15 91.1 88.9 90.95 89.75 90.8 90.65 90.1 91.15"
        />
        <path
          fill="#f3b3c9"
          d="M89.15 89.15 L88.2 89.25 Q87.85 88.9 88.5 88.45 L89.0 88.25 89.4 88.35 Q89.75 88.7 89.15 89.15"
        />
      </g>
    </svg>
  );
};

export default Weedle;
